import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import useGetFiltersInfo from '../hooks/useGetFiltersInfo';
import OptionsSelector from '../ui/OptionsSelector';

const CabsFilter = ({ type }) => {
  const {
    data, prevData, params, updateParams,
  } = useGetFiltersInfo();
  const { t } = useTranslation('search');

  const options = data?.cabs || prevData?.cabs || [];

  const onChange = (value) => {
    updateParams({
      cabs: value,
      page: 1,
    });
  };

  return (
    <OptionsSelector
      id="cabs-filter"
      onChange={onChange}
      options={options}
      placeholder={t('Search')}
      type={type}
      value={params.cabs}
    />
  );
};

CabsFilter.propTypes = {
  type: PropTypes.string.isRequired,
};

export default CabsFilter;
